export default class ChatInterfaceBase {
    constructor(loginData, constraints) {
        this._loginData = loginData;
        this._constraints = constraints;

        this.events = {};
    }

    setAuthParams(params) {
        this._loginData = {...this._loginData, ...params};
    }

    getUid() {
        return this._loginData.current_user.id
    }

    getToken() {
        return this._loginData.current_user.token;
    }

    getGuestNick() {
        return this._guestNick;
    }

    setGuestNick(nick) {
        this._guestNick = nick;
    }

    getServerId() {
        return this._loginData.server_id;
    }

    getValidGenders() {
        return this._loginData.valid_genders;
    }

    // example: 'Salle principale'
    getDefaultRoomId() {
        return this._loginData.default_roomid;
    }

    // example: NEO I
    getChatRoomName() {
        return this._loginData.chatroom_name;
    }

    // example: https://media10.bobtv.co
    getStaticUrlPrefix() {
        return this._loginData.static_url_prefix;
    }

    getPrimaryRoomURL() {
        return this._loginData.primary_room_url;
    }

    // example: NEO I
    getPrimaryRoomName() {
        return this._loginData.primary_room_name;
    }

    getSecondaryRoomURL() {
        return this._loginData.secondary_room_url;
    }

    // example: NEO II
    getSecondaryRoomName() {
        return this._loginData.secondary_room_name;
    }

    isAnonymous() {
        return !this._loginData.current_user.id || !this.isActivated()
    }

    isActivated() {
        return this._loginData.current_user.active === 1;
    }

    isCertified() {
        return this._loginData.current_user.certified === 1;
    }

    isCertificationDisabled() {
        return this._loginData.current_user.certification_disabled && this._loginData.current_user.certification_disabled === 1;
    }

    isVideoOpenRequested() {
        return !!this._loginData.ufrag;
    }

    _getLoginConfig() {
        if (this.isAnonymous()) {
            return {
                Nick: this.getGuestNick(),
                ServerUri: this._loginData.server_uri,
                RoomId: this._loginData.roomid,
                AdditionalInfo: this._loginData.connection_id,
                PaymentAllowed: this._loginData.payment_allowed
            }
        }

        return {
            Uid: this.getUid(),
            Token: this.getToken(),
            ServerUri: this._loginData.server_uri,
            RoomId: this._loginData.roomid,
            AdditionalInfo: this._loginData.connection_id,
            PaymentAllowed: this._loginData.payment_allowed
        }
    }

    on(event, handler) {
        var events = [];

        if (typeof event == 'string') {
            events.push(event);
        } else if (typeof event == 'object' && event.length) {
            events = [...event];
        }

        for (var index = 0; index < events.length; index++) {
            var evt = events[index];
            if (!this.events[evt]) {
                this.events[evt] = [];
            }
            this.events[evt].push(handler);
        }
    }

    trigger(event) {
        if (this.events[event]) {
            for (var index in this.events[event]) {
                this.events[event][index].call(null, ...Array.prototype.slice.call(arguments, 1));
            }
        }
    }

    onRoomClientList(handler) { this.on('room_client_list', handler) }
    onRoomClientLogin(handler) { this.on('room_client_login', handler) }
    onRoomClientUpdate(handler) { this.on('room_client_update', handler) }
    onRoomClientLogout(handler) { this.on('room_client_logout', handler) }

    onStatusMotd(handler) { this.on('status_motd', handler) }
    onRoomMessage(handler) { this.on('room_message', handler) }
    onServiceMessage(handler) { this.on('service_message', handler) }

    onPreLogin(handler) { this.on('prelogin', handler) }
    onLoginSuccess(handler) { this.on('login_success', handler) }
    onLoginError(handler) { this.on('login_error', handler) }
    onClose(handler) { this.on('close', handler) }
    onDisconnect(handler) { this.on('disconnect', handler) }
    onPreReconnect(handler) { this.on('prereconnect', handler) }

    onStreamView(handler) { this.on('stream_view', handler) }
    onStreamViewStart(handler) { this.on('stream_view_success', handler) }
    onStreamViewStop(handler) { this.on('stream_view_stop', handler) }
    onStreamViewReconnect(handler) { this.on('stream_view_reconnect', handler) }
    onStreamLeave(handler) { this.on('stream_leave', handler) }
    onStreamWatchingMe(handler) { this.on('stream_watching_me', handler) }
    onStreamWatcherCount(handler) { this.on('stream_watcher_count', handler) }
    onStreamStreamUpdate(handler) { this.on('stream_stream_update', handler) }
    onStreamLimitReached(handler) { this.on('stream_limit_reached', handler) }
    onStreamingStartSuccess(handler) { this.on('streaming_start_success', handler) }
    onStreamingStartError(handler) { this.on('streaming_start_error', handler) }

    onPmConversations(handler) { this.on('pm_conversations', handler)};
    onPmConversationChanged(handler) { this.on('pm_conversation_changed', handler) };

    onRoomClientList(handler) { this.on('room_client_list', handler) }
    onRoomClientLogin(handler) { this.on('room_client_login', handler) }
    onRoomClientUpdate(handler) { this.on('room_client_update', handler) }
    onRoomClientLogout(handler) { this.on('room_client_logout', handler) }

    onPmSessionStart(handler) { this.on('pm_session_start', handler) };

    onPmUserUpdate(handler) { this.on('pm_user_update', handler) }

    onPmSessionAccepted(handler) { this.on('pm_session_accepted', handler) };
    onPmSessionDeclined(handler) { this.on('pm_session_declined', handler) };
    onPmRequestCancelled(handler) { this.on('pm_request_cancelled', handler) };
    onPmSessionRevoked(handler) { this.on('pm_session_revoked', handler) };

    onPmAccessRequest(handler) { this.on('pm_access_request', handler) };
    onPmAccessChangeAllowed(handler) { this.on('pm_access_change_allowed', handler) };
    onPmAccessChangeDenied(handler) { this.on('pm_access_change_denied', handler) };
    onPmAccessChangeUndefined(handler) { this.on('pm_access_change_undefined', handler) };
    onPmHistory(handler) { this.on('pm_history', handler) };

    onPmMessage(handler) { this.on('pm_message', handler) };
    onTypingNotify(handler) { this.on('typing_notify', handler) };
    onDeleteHistory(handler) { this.on('delete_history', handler) };

    onRoomList(handler) { this.on('room_list', handler) };
    onRoomSwitched(handler) { this.on('room_switched', handler) };
    onRoomJoined(handler) { this.on('room_joined', handler) };
    onRoomLeaved(handler) { this.on('room_leaved', handler) };
    onRoomDestroyed(handler) { this.on('room_destroyed', handler) };
    onRoomUpdated(handler) { this.on('room_updated', handler) };

    onRoomSubscriptionPaymentFailed(handler) { this.on('room_subscription_payment_failed', handler)};

    sendRoomMessage(message, success, error) { };
    sendPmMessage(message, to, success, error) { };
    allowPmAccess(ufrag) {  };
    denyPmAccess(ufrag) {  };
    resetPmAccess(ufrag) {  };

    getRoomList(Success, Error) {};
    loginVirtualRoom(Name, Password, Success, Error) {};
    createVirtualRoom(Name, Password, Success, Error) {};
    destroyVirtualRoom(RoomId, Success, Error) {};
}



// WEBPACK FOOTER //
// ./src/interfaces/chat/base.js